export default __webpack_public_path__ + "static/media/logo-ergonomics.285cab12.svg";